import slugifyFn from 'slugify';

interface Slugify {
  str: string;
  lower?: boolean;
  strict?: boolean;
}

export const slugify = ({ str, lower = true, strict = true }: Slugify) =>
  slugifyFn(str, { lower, strict });
